/*
Import the CSS for your template, the slug does not have to match.
*/
import "../../styles/@slug/home.scss";